import { jwtDecode } from 'jwt-decode';
import {
  createRouter,
  createWebHistory,
} from 'vue-router';
import {
  ROUTE_TO_ACCEPT_MESSAGE_TYPES,
} from '@/config/constant';
// import {
//   getAuthCookie,
// } from '@/utils/cookie';
// import useUserStore from '@/stores/user';
// import useDataStore from '@/stores/data';

const routes = [
  {
    path: '/loading',
    name: 'init load',
    component: () => import('@/views/InitLoading.vue'),
    meta: {
      layout: 'none-layout',
      requiresAuth: false,
    },
  },
  {
    path: '/',
    redirect: '/loading',
  },
  {
    path: '/index.html',
    redirect: '/loading',
  },
  {
    path: '/message',
    name: 'message composer',
    component: () => import('@/views/MessageComposer.vue'),
    meta: {
      layout: 'three-column-layout',
      requiresAuth: true,
      messageTypes: ROUTE_TO_ACCEPT_MESSAGE_TYPES.message,
    },
  },
  {
    path: '/kakao',
    name: 'kakao friendtalk message composer',
    component: () => import('@/views/KaKaoMessageComposer.vue'),
    meta: {
      layout: 'three-column-layout',
      requiresAuth: true,
      messageTypes: ROUTE_TO_ACCEPT_MESSAGE_TYPES.kakao,
    },
  },
  {
    path: '/alimtalk',
    name: 'kakao alimtalk message composer',
    component: () => import('@/views/KaKaoAlimtalkComposer.vue'),
    meta: {
      layout: 'three-column-layout',
      requiresAuth: true,
      messageTypes: ROUTE_TO_ACCEPT_MESSAGE_TYPES.alimtalk,
    },
  },
  {
    path: '/brand',
    name: 'kakao brandtalk message composer',
    component: () => import('@/views/BrandMessageComposer.vue'),
    meta: {
      layout: 'three-column-layout',
      requiresAuth: true,
      messageTypes: ROUTE_TO_ACCEPT_MESSAGE_TYPES.brand,
    },
  },
  {
    path: '/hover',
    name: 'hover',
    component: () => import('@/views/HoverView.vue'),
    meta: {
      layout: 'none-layout',
      requiresAuth: true,
    },
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('@/views/MessageDetails.vue'),
    meta: {
      layout: 'message-result-layout',
      requiresAuth: true,
    },
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('@/views/MessageResult.vue'),
    meta: {
      layout: 'message-result-layout',
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  routes,
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, _, next) => {
  const token = sessionStorage.getItem('accessToken');
  // const { userInfo } = useUserStore();
  // const { init } = useDataStore();

  if (!to.meta.requiresAuth) {
    next();
    return;
  }

  if (!token) {
    next();
    // next('/loading');
    return;
  }

  try {
    const payload = jwtDecode(token);
    const exp = payload?.exp ?? 0;

    if (exp < Date.now() / 1000) {
      await sessionStorage.clear();
    }

    next();
  } catch (error) {
    // TODO alert
    next('');
  }
});

export default router;

export const messageTypesMap = {};

routes
  .filter(({ meta }) => meta?.messageTypes)
  .forEach(({ path, meta: { messageTypes } }) => {
    messageTypes.forEach((key) => {
      messageTypesMap[key] = path;
    });
  });
